import { RouteRedirectConfig } from './types/route-redirect-config';

export const routeRedirects: RouteRedirectConfig[] = [];
